import { Carrier } from '../../../../../core';

const iconsOfActionsList = [
  {
    icon: 'edit',
    tooltip: 'editar',
    hasVisibleCondition: (element: Carrier[]): boolean => element.length >= 1
  }
];

export const carrier = {
    searchText: 'Buscar transportista',
    addText: 'Transportista',
    export: false,
    dialogHability: true,
    filter: false,
    checkbox: true,
    checkboxHeader: false,
    disabled: false,
    partialField: '',
    iconsOfActions: iconsOfActionsList,
    hasDisabledCheckBoxItem: (row: Carrier, selection: Carrier[]) => {
      if (selection.length > 0 && row) {
        return selection.length === 1 && row.id === selection[0].id ? false : true;
      } else {
        return false;
      }
    },
    columns: [
      {
        title: 'RUC',
        name: 'ruc',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: Carrier) => element.ruc
      },
      {
        title: 'Razón social',
        name: 'businessName',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: Carrier) => element.businessName
      },
      /*  {
         title: 'Empresa',
         name: 'companyName',
         type: 'string',
         editable: false,
         checkAll: false,
         class: 'left',
         value: (element: Carrier) => element.companyName
       }, */
      {
        title: 'Fecha de creación',
        name: 'dateCreated',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: Carrier) => element.dateCreated
      },
      {
        title: 'N° de placas',
        name: 'num_license',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: Carrier) => element.plateList.length
      },
      {
        title: 'Estado',
        name: 'active',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: Carrier) => element.active === true ? 'ACTIVO' : 'INACTIVO'
      },
      {
        title: 'Placas',
        name: 'plateList',
        placeholderHidden: true,
        type: 'select',
        editable: true,
        checkAll: false,
        class: 'ASU-007',
        value: (element: Carrier) => element.plateList
      }
    ]
  };
